import i18n from '../../locales/index'
import InforCard from './infor-card.vue'
export default InforCard
